<template>
  <div class="ride-booking-driver">
    <div class="card">
      <div class="card-content has-text-left">
        <div class="columns is-mobile">
          <div class="column is-narrow">
            <img :src="driverPic" />
          </div>
          <div class="column middle">
            <p class="driver-details">Driver</p>
            <div class="driver-buttons">
              <button class="button is-white has-text-link" @click="callDriver">
                <i class="fa fa-phone" /></button
              >&nbsp;
              <button class="button is-white has-text-link" @click="chat">
                <i class="fa fa-comments" />
              </button>
            </div>
            <p class="single-line no-scrollbar has-text-weight-medium">
              {{ driver.name }}
            </p>
            <p class="single-line no-scrollbar">
              <!-- <i class="fa fa-ticket-alt pad" />&nbsp; -->
              <i style="margin-right: 3px">{{ $t("profile.vehicle") }}</i>
              <span class="tag is-grey plate">{{ vehicleNumber }}</span>
            </p>
          </div>
          <div class="column is-narrow">
            <img v-if="vehiclePic" class="profile-pic" :src="vehiclePic" />
            <div
              v-else-if="vehicleColor"
              class="vehicle-color center"
              :style="vehicleColorStyle"
              @click="infoToast('Vehicle color')"
            >
              <span>{{ $t("ride.vehicle-color") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import vehicles from "@/vehicles";

export default {
  name: "RideBookingDriver",
  props: {
    driver: Object, // transaction
  },
  data() {
    return {};
  },
  computed: {
    driverPic() {
      return this.driver.profile_pic_url || vehicles.img();
    },
    vehiclePic() {
      return this.driver.role.data.vehicle_pic_url;
    },
    vehicleColor() {
      // return "white";
      return this.driver.role.data.vehicle_color;
    },
    vehicleColorStyle() {
      var color = this.vehicleColor || "white";
      return `background-color:${color};`;
    },
    vehicleNumber() {
      return this.driver.role.data.vehicle_number;
    },
  },
  methods: {
    // driverUpdatedInfo() {
    //   var ago = this.timeAgo(this.t.driver.user_state.updated_at);
    //   this.infoToast(`Driver last updated ${ago}`);
    // },
    callDriver() {
      // depending on what each business wants this could
      // call the actual driver or the main business number
      var phone = this.driver.phone_number; // this.t.business.phone_number;
      window.location.href = `tel:${phone}`;
    },
    chat() {
      var title = this.$t("ride.message-driver");
      this.$swal({
        html: `<div style='font-size:1.2em; text-align:left'>
        <i class='far fa-comment fa-lg'></i>&nbsp;${title}</div>`,
        input: "text",
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("send"),
      }).then((val) => {
        if (val.value) this.sendMessage(val.value, "push", this.driver.id);
      });
    },
    // move to shared func
    sendMessage(msg, type, userID) {
      this.infoToast("<i class='fa fa-spinner fa-spin'></i>", "top", 1000);
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: userID,
          message: msg,
          type: type, // send type: sms or push
        })
        .then(() => {
          this.successToast(this.$t("ride.your-message-has-been-sent"), "top");
        })
        .catch((err) => {
          if (type === "push") {
            this.sendMessage(msg, "sms", userID);
          } else this.apiError(err); // first try sms if push err
        });
    },
  },
};
</script>

<style scoped>
.card-content {
  padding: 12px;
  /* border-top: 1px solid rgba(128, 128, 128, 0.2); */
}
img {
  height: 75px;
  width: 75px;
  border-radius: 3px;
  /* border: 1px solid gold; */
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  object-fit: cover;
}
.is-narrow {
  padding-bottom: 0;
}
.driver-details {
  font-weight: 550;
  opacity: 0.7;
  display: inline-block;
  padding-bottom: 5px;
}
.driver-buttons {
  display: inline-block;
  position: absolute;
  margin-top: -7px;
  margin-left: 10px;
}
.middle {
  max-width: calc(100vw - 200px);
  padding-left: 0;
  padding-right: 0;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
}
.plate {
  padding: 5px;
  font-weight: 550;
  opacity: 0.6;
  border: 1px solid rgb(236, 236, 236);
  /* max-width: 60px; */
  /* overflow: hidden; */
}
.vehicle-color {
  border-radius: 3px;
  border: rgba(0, 0, 0, 0.15) 1px solid;
  height: 80px;
  width: 80px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  text-align: center;
  line-height: 80px;
}
.vehicle-color span {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  font-weight: 500;
  color: white;
  font-size: 0.9em;
  text-shadow: 0 0 3px black;
}
</style>